<div class="console_modal chat_settings_dialog">
  <div class="modal-header">
    <h4 class="modal-title">User data configuration</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.close()">
      <i class="fa-solid fa-xmark" aria-hidden="true"></i>
    </button>
  </div>
  <div class="modal-body" [formGroup]="settingsForm">
    <div class="row mb-3">
      <div class="col-12">
          <h3>
            Parameters Map
            @if (parametersMap.invalid && settingsSubmitted) {
              <i class="far fa-exclamation-circle text-danger" aria-hidden="true"></i>
            }
          </h3>
          <div class="body_content" formArrayName="parametersMap">
            @if (parametersMap.controls.length > 0) {
              <div class="row mb-3">
                <div class="col-4 offset-1">
                  <span>Parameters name</span>
                </div>
                <div class="col-4">
                  <span>Parameters value</span>
                </div>
              </div>
            }
            @for (parametersForm of parametersMap.controls; track parametersForm; let i = $index) {
              <div class="row mb-3" [formGroupName]="i">
                <div class="col-1 d-flex justify-content-center align-items-center">
                  <div class="form-check" ngbTooltip="Use only for next interaction">
                    <input type="checkbox" class="form-check-input" id="parametersMap_{{ i }}" formControlName="removeOnSubmit" />
                    <label class="form-check-label" for="parametersMap_{{ i }}"></label>
                  </div>
                </div>
                <div class="col-4">
                  <input type="text" class="form-control" required placeholder="Key" formControlName="key" [ngClass]="{ 'is-invalid': parametersForm.get('key')?.invalid && settingsSubmitted }" />
                  @if (parametersForm.get('key')?.errors?.['required']) {
                    <div class="invalid-feedback">Key is required</div>
                  }
                </div>
                <div class="col-4">
                  <input type="text" class="form-control" required placeholder="Value" formControlName="value" [ngClass]="{ 'is-invalid': parametersForm.get('value')?.invalid && settingsSubmitted }" />
                  @if (parametersForm.get('value')?.errors?.['required']) {
                    <div class="invalid-feedback">Value is required</div>
                  }
                </div>
                <div class="col-2">
                  <button class="btn" (click)="parametersMap.removeAt(i)"><i class="far fa-times-circle" aria-hidden="true"></i></button>
                </div>
              </div>
            }
            <div class="row">
              <div class="col">
                <a href="javascript:void(0)" (click)="parametersMap.push(getParamForm())">
                  <small><i class="fas fa-plus" aria-hidden="true"></i> Add</small>
                </a>
              </div>
            </div>
          </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="form-check">
          <input type="checkbox" class="form-check-input" id="enableAudioOutput" formControlName="outputAudio" />
          <label class="form-check-label" for="enableAudioOutput">Audio Output</label>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <div class="navbar p-0 btn-group">
      <button id="saveTestButton" type="button" class="btn brand_default" (click)="saveSettings(false)">Save</button>
        <fieldset class="btn-group" ngbDropdown aria-label="Button group with nested dropdown">
          <button class="btn brand_default dropdown-toggle" ngbDropdownToggle id="dropdownTestReference"></button>
        <div class="dropdown-menu dropdown-menu-right" ngbDropdownMenu aria-labelledby="dropdownTestReference">
          <button id="saveAndRunButton" class="dropdown-item text_brand" ngbDropdownItem (click)="saveSettings(true)">Save & Refresh</button>
        </div>
        </fieldset>
      </div>
  </div>
</div>
